import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { tongji } from '../utils/api';
import styles from './index.css';
/* 红包 */
// @flow
class Hongbao extends PureComponent {
    constructor(props) {
        super(props);
        // 关闭
        this.handleCloseClick = () => {
            this.setState({ display: false });
        };
        // 跳转
        this.handleHrefClick = () => {
            const { content, tjKey } = this.props;
            window.location.href = content.url;
            tongji(tjKey);
        };
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';
        this.state = {
            display: !ua.match(/MicroMessenger/gi),
        };
    }
    render() {
        const { display } = this.state;
        const { content } = this.props;
        if (typeof document === 'object' && content && display) {
            return ReactDOM.createPortal(React.createElement("div", { className: styles.box },
                React.createElement("div", { className: styles.hongbaoBox },
                    React.createElement("a", { onClick: this.handleHrefClick },
                        React.createElement("img", { className: styles.image, src: content.image, width: content.width, height: content.height })),
                    React.createElement("i", { className: styles.close, onClick: this.handleCloseClick }))), document.body);
        }
        return null;
    }
}
export default Hongbao;
